export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SearchBar.vue?vue&type=template&id=1c22a5b6&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/SearchBar.vue?vue&type=template&id=1c22a5b6&
// module id = null
// module chunks = 